import React from 'react';
import { Header, Credentials, Dots, ProfileList } from './';
import DeviceSVG from '../svg/DeviceSVG';
import Persons from '../data/persons.json';

const ArrowIcon = () =>
  <svg
    className="icon-text"
    height="10px"
    version="1.1"
    viewBox="0 0 8 12"
    width="7px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fillRule="evenodd" id="Symbols" stroke="none" strokeWidth="1">
      <g fill="#FFFFFF" id="Web/Submit/Active" transform="translate(-148.000000, -32.000000)">
        <polygon id="Shape" points="148 33.4 149.4 32 155.4 38 149.4 44 148 42.6 152.6 38" />
      </g>
    </g>
  </svg>;

class Widget extends React.Component {
  constructor() {
    /* eslint-env browser */
    super();

    this.person = this.getNewPerson();

    const preloadImage = new Image();
    preloadImage.src = this.person.sampleAppUrl;

    this.typePassword = this.typePassword.bind(this);
    this.startLockDemo = this.startLockDemo.bind(this);
    this.startAdditionalElements = this.startAdditionalElements.bind(this);
    this.setStatePromise = this.setStatePromise.bind(this);
    this.stop = false;
  }

  state = {
    loggedIn: false,
    welcomeText: 'Auth0',
    gravatar: false,
    gravatarUrl: 'https://cdn.auth0.com/styleguide/components/1.0.8/media/logos/img/badge.png',
    sampleAppUrl: '',
    typing1: false,
    typing2: false,
    focused: 0,
    values: {
      user: '',
      pwd: ''
    },
    placeholders: {
      user: 'Username',
      pwd: 'Password'
    },
    dots: false,
    profile: false
  };

  componentDidMount() {
    this.startLockDemo();
  }

  componentWillUnmount() {
    this.stop = true;
  }

  getNewPerson = () => {
    const randomPersonIndex = Math.floor(Math.random() * Persons.length);
    return Persons[randomPersonIndex];
  };

  setStatePromise = (newState, delay) =>
    new Promise(resolve => {
      setTimeout(() => {
        if (this.stop) {
          return resolve();
        }
        return this.setState(newState, () => {
          resolve();
        });
      }, delay);
    });

  startLockDemo = () => {
    const newPlaceholderState = {
      placeholders: { user: '', pwd: 'Password' }
    };

    const newValues = {
      user: this.person.email,
      pwd: '••••••••••'
    };

    this.setStatePromise({ focused: 1, sampleAppUrl: this.person.sampleAppUrl }, 500)
      .then(this.setStatePromise({ typing1: true, values: newValues }, 500))
      .then(this.setStatePromise(newPlaceholderState, 200));
  };

  typePassword = () => {
    const exampleAppState = {
      welcomeText: `ようこそ ${this.person.name}さん`,
      gravatarUrl: this.person.gravatarUrl,
      gravatar: true,
      typing2: true,
      focused: 2
    };

    const placeholdersState = {
      placeholders: {
        user: '',
        pwd: ''
      }
    };

    this.setStatePromise(exampleAppState, 300).then(this.setStatePromise(placeholdersState, 300));
  };

  startAdditionalElements = () => {
    this.setStatePromise({ focused: 3 }, 100)
      .then(this.setStatePromise({ loggedIn: true, focus: 0 }, 1000))
      .then(this.setStatePromise({ profile: true }, 1000))
      .then(this.setStatePromise({ dots: true }, 2000));
  };

  render() {
    const lockDevice = (
      <div className="device">
        <form className="auth0-lock-demo-homepage">
          <div className="auth0-lock-widget-container">
            <div className="screen1">
              <div className="auth0-lock-cred-pane auth0-lock-quiet">
                <Header
                  text={this.state.welcomeText}
                  gravatar={this.state.gravatar}
                  gravatarUrl={this.state.gravatarUrl}
                />
                <Credentials
                  focused={this.state.focused}
                  values={this.state.values}
                  placeholders={this.state.placeholders}
                  typing1={this.state.typing1}
                  typing2={this.state.typing2}
                  onDone1={this.typePassword}
                  onDone2={this.startAdditionalElements}
                />

                <button
                  className={`auth0-lock-submit ${this.state.focused === 3
                    ? 'auth0-lock-submit-focused '
                    : ''}`}
                  style={{ backgroundColor: '#eb5424' }}
                  type="submit"
                >
                  <div className="auth0-loading-container">
                    <div className="auth0-loading" />
                  </div>
                  <span className="auth0-label-submit">
                    ログイン
                    <ArrowIcon />
                  </span>
                </button>
              </div>
            </div>
            <div className={`${this.state.loggedIn ? ' screen2-active' : ''} screen2`}>
              <img src={this.state.sampleAppUrl} alt="Sample app" />
            </div>
          </div>
          <DeviceSVG />
        </form>
      </div>
    );

    return (
      <div className="identity-animation">
        {this.state.profile && <ProfileList profile={this.person.profile} />}
        {this.state.dots && <Dots connection={this.person.connection} />}
        {lockDevice}
      </div>
    );
  }
}

export default Widget;



// WEBPACK FOOTER //
// ./src/pages/jp/homepage/components/LockHomeDemo/components/Widget.js